import createIcon from '../../createIcon';

/**
 * @component @name DirectionsBoatFilled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMjFDMTguNjEgMjEgMTcuMjIgMjAuNTMgMTYgMTkuNjhDMTMuNTYgMjEuMzkgMTAuNDQgMjEuMzkgOCAxOS42OEM2Ljc4IDIwLjUzIDUuMzkgMjEgNCAyMUgyVjIzSDRDNS4zOCAyMyA2Ljc0IDIyLjY1IDggMjIuMDFDMTAuNTIgMjMuMyAxMy40OCAyMy4zIDE2IDIyLjAxQzE3LjI2IDIyLjY2IDE4LjYyIDIzIDIwIDIzSDIyVjIxSDIwWk0zLjk1IDE5SDRDNS42IDE5IDcuMDIgMTguMTIgOCAxN0M4Ljk4IDE4LjEyIDEwLjQgMTkgMTIgMTlDMTMuNiAxOSAxNS4wMiAxOC4xMiAxNiAxN0MxNi45OCAxOC4xMiAxOC40IDE5IDIwIDE5SDIwLjA1TDIxLjk1IDEyLjMyQzIyLjA2IDExLjk1IDIxLjk5IDExLjI2IDIxLjI5IDExLjA0TDIwIDEwLjYyVjZDMjAgNC45IDE5LjEgNCAxOCA0SDE1VjFIOVY0SDZDNC45IDQgNCA0LjkgNCA2VjEwLjYyTDIuNzEgMTEuMDRDMi4wOCAxMS4yMyAxLjkgMTEuODggMi4wNSAxMi4zMkwzLjk1IDE5Wk02IDZIMThWOS45N0wxMiA4TDYgOS45N1Y2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DirectionsBoatFilled = createIcon('DirectionsBoatFilled', [
  [
    'path',
    {
      d: 'M20 21C18.61 21 17.22 20.53 16 19.68C13.56 21.39 10.44 21.39 8 19.68C6.78 20.53 5.39 21 4 21H2V23H4C5.38 23 6.74 22.65 8 22.01C10.52 23.3 13.48 23.3 16 22.01C17.26 22.66 18.62 23 20 23H22V21H20ZM3.95 19H4C5.6 19 7.02 18.12 8 17C8.98 18.12 10.4 19 12 19C13.6 19 15.02 18.12 16 17C16.98 18.12 18.4 19 20 19H20.05L21.95 12.32C22.06 11.95 21.99 11.26 21.29 11.04L20 10.62V6C20 4.9 19.1 4 18 4H15V1H9V4H6C4.9 4 4 4.9 4 6V10.62L2.71 11.04C2.08 11.23 1.9 11.88 2.05 12.32L3.95 19ZM6 6H18V9.97L12 8L6 9.97V6Z',
      key: '28473y',
    },
  ],
]);

export default DirectionsBoatFilled;
